<template>
    <div 
        class="lojas-dropdown"
        :style="cssVars"
    >
        <div 
            v-if="Object.keys(usuarioLojas).length <= 1"
            class="user-panel"
        >
            <div class="text-center image">
                <a :href="$urlBase + '/inicio'" border="0">
                    <img 
                        :src="usuarioLogado.Loja.caminho_logomarca" 
                        width="150" 
                        :alt="usuarioLogado.Loja.nome"
                    >
                </a>
            </div>
        </div>

        <div 
            v-else
            class="loja-principal"
            @click="toggleDropdown"
        >
            <div class="loja-header">
                <div class="loja-icone">
                    <img 
                        :src="usuarioLogado.Loja.caminho_logomarca + '?v=' + new Date().getTime()" 
                        :alt="usuarioLogado.Loja.nome"
                    >
                </div>
                <div class="loja-info">
                    <span class="loja-nome">{{ usuarioLogado.Loja.nome }}</span>
                    <span 
                        v-if="usuarioLogado.Loja.cnpj || usuarioLogado.Loja.cpf || usuarioLogado.Loja.documento"
                        class="loja-dados"
                    >
                        {{ usuarioLogado.Loja.cnpj || usuarioLogado.Loja.cpf || usuarioLogado.Loja.documento }}
                    </span>
                </div>
                <div class="seta-dropdown">
                    <i :class="['fa', isOpen ? 'fa-angle-up' : 'fa-angle-down']"></i>
                </div>
            </div>
        </div>
        
        <transition name="slide-fade">
            <div 
                v-if="isOpen && Object.keys(usuarioLojas).length > 1" 
                class="dropdown-lojas"
                :class="{ 'com-scroll': usuarioLojasOrdenadas.length > 5 }"
            >
                <div 
                    v-if="usuarioLojasOrdenadas.length > 5" 
                    class="busca-lojas"
                >
                    <i class="fa fa-search"></i>
                    <input 
                        v-model="termoBusca"
                        type="text"
                        placeholder="Buscar loja..."
                        @click.stop
                    >
                </div>

                <div 
                    v-for="(usuarioLoja, id) in lojasFiltradas"
                    :key="id"
                    class="loja-item"
                    :class="{ 'active': usuarioLogado.Loja.id == usuarioLoja.UsuariosLoja.loja_id }"
                    @click="alterarLoja(usuarioLoja)"
                >
                    <div class="loja-item-icone">
                        <img 
                            v-if="usuarioLoja.caminho_logomarca"
                            :src="usuarioLoja.caminho_logomarca"
                            :alt="usuarioLoja.Loja.nome"
                            @error="onItemImageError($event, usuarioLoja)"
                        >
                        <i 
                            v-else 
                            class="fa fa-briefcase"
                        ></i>
                    </div>
                    <div class="loja-item-info">
                        <span class="loja-item-nome">{{ usuarioLoja.Loja.nome }}</span>
                        <span 
                            v-if="usuarioLoja.documento" 
                            class="loja-item-documento"
                        >
                            {{ usuarioLoja.documento }}
                        </span>
                    </div>
                    <div 
                        v-if="usuarioLogado.Loja.id == usuarioLoja.UsuariosLoja.loja_id" 
                        class="loja-check"
                    >
                        <i class="fa fa-check"></i>
                    </div>
                </div>

                <div 
                    v-if="lojasFiltradas.length === 0 && termoBusca" 
                    class="sem-resultados"
                >
                    Nenhuma loja encontrada
                </div>
                
                <a 
                    :href="$urlBase + '/lojas'" 
                    class="gerenciar-lojas"
                >
                    Gerenciar todas as lojas
                </a>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    data() {
        return {
            usuarioLogado: this.$usuarioLogado,
            usuarioLojas: this.$usuarioLogado.UsuarioLojas,
            isOpen: false,
            termoBusca: ''
        }
    },
    
    computed: {
        cssVars() {
            return {
                '--cor-loja': '#' + this.$app.cor_primaria
            }
        },
        usuarioLojasOrdenadas() {
            return [...this.usuarioLogado.UsuarioLojas].sort((a, b) => {
                const nomeA = a.Loja.nome.toUpperCase();
                const nomeB = b.Loja.nome.toUpperCase();
                return nomeA.localeCompare(nomeB);
            });
        },
        lojasFiltradas() {
            if (!this.termoBusca.trim()) {
                return this.usuarioLojasOrdenadas;
            }
            const termo = this.termoBusca.toLowerCase().trim();
            return this.usuarioLojasOrdenadas.filter(loja => 
                loja.Loja.nome.toLowerCase().includes(termo)
            );
        }
    },
    
    methods: {
        toggleDropdown() {
            if (Object.keys(this.usuarioLojas).length > 1) {
                this.isOpen = !this.isOpen;
                if (!this.isOpen) {
                    this.termoBusca = '';
                }
            }
        },
        
        onItemImageError(e, loja) {
            e.target.style.display = 'none';
            loja.caminho_logomarca = null;
        },
        
        alterarLoja(loja) {
            if (this.usuarioLogado.Loja.id == loja.UsuariosLoja.loja_id) {
                this.isOpen = false;
                return this.$dialog.warning(
                    'Você já está logado na loja ' + loja.Loja.nome + '!'
                )
            }
            this.$dialog.confirm(
                'Deseja logar na ' 
                + 
                (this.$urlBase == '/contabilidade' 
                    ? 'contabilidade' 
                    : 'loja'
                ) 
                + ' ' 
                + loja.Loja.nome 
                + '?', {
                icon: 'fa icon-store mb-3 mt-2',
            }).then(retorno => {
                if (retorno) {
                    this.$loading.show()
                    this.$api.cPost(this.$urlBase + '/lojas/logar', {
                        'loja': loja.UsuariosLoja.loja_id
                    }).then(() => {
                        location.reload()
                    })
                }
            })
            this.isOpen = false;
        }
    },
    
    mounted() {
        document.addEventListener('click', (e) => {
            if (!this.$el.contains(e.target)) {
                this.isOpen = false;
                this.termoBusca = '';
            }
        });
    }
}
</script>

<style scoped>
.lojas-dropdown {
    width: 100%;
    font-family: inherit;
    border-radius: 50%;
    overflow: visible;
    position: relative;
}

.user-panel img {
    border-radius: var(--raio);
}

.loja-principal {
    margin: 15px 10px;
    background: var(--cor-loja);
    cursor: pointer;
    transition: all 0.3s ease;
    border-radius: var(--raio-lg);
}

.loja-principal:hover {
    filter: brightness(0.9);
}

.loja-header {
    display: flex;
    align-items: center;
    padding: 12px 14px;
    gap: 10px;
}

.loja-icone {
    width: 40px;
    height: 40px;
    border-radius: var(--raio);
    overflow: hidden;
    flex-shrink: 0;
}

.loja-icone img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
    padding: 5px;
    background: rgba(255, 255, 255, 0.3);
}

.loja-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.loja-nome {
    font-size: 13px;
    font-weight: 700;
    color: #fff;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.loja-dados {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.85);
    margin-top: 2px;
}

.loja-completar {
    font-size: 11px;
    color: #fff !important;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 4px;
}

.seta-dropdown {
    color: #fff;
    font-size: 18px;
    padding: 4px;
}

.dropdown-lojas {
    position: absolute;
    top: 100%;
    left: 10px;
    right: 10px;
    background: #fff;
    border-radius: var(--raio);
    box-shadow: 0 3px 20px rgba(0, 0, 0, 0.15);
    margin-top: 5px;
    z-index: 1000;
}

/* Adiciona scroll se tiver mais de 5 lojas */
.dropdown-lojas.com-scroll {
    max-height: 350px;
    overflow-y: auto;
}

/* Campo de busca */
.busca-lojas {
    display: flex;
    align-items: center;
    padding: 10px 14px;
    border-bottom: 1px solid #f0f0f0;
    gap: 10px;
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 1;
    border-radius: var(--raio) var(--raio) 0 0;
}

.busca-lojas i {
    color: #9CA3AF;
    font-size: 14px;
}

.busca-lojas input {
    flex: 1;
    border: none;
    outline: none;
    font-size: 13px;
    color: #1F2937;
    background: transparent;
}

.busca-lojas input::placeholder {
    color: #9CA3AF;
}

.loja-item {
    display: flex;
    align-items: center;
    padding: 12px 14px;
    gap: 10px;
    cursor: pointer;
    transition: background 0.2s ease;
    border-bottom: 1px solid #f5f5f5;
}

.loja-item:hover {
    background: rgba(0, 0, 0, 0.05);
}

.loja-item:last-of-type {
    border-bottom: none;
}

.loja-item.active {
    background: rgba(0, 0, 0, 0.05);
}

.loja-item.active .loja-item-nome {
    color: var(--cor-loja);
    font-weight: 600;
}

.loja-item-icone {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.05);
    /* border: 2px solid var(--cor-loja); */
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    overflow: hidden;
}

.loja-item-icone img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.loja-item-icone i {
    color: var(--cor-loja);
    font-size: 12px;
}

.loja-item-info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
}

.loja-item-nome {
    font-size: 13px;
    font-weight: 500;
    color: #1F2937;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.loja-item-documento {
    font-size: 11px;
    color: #9CA3AF;
    margin-top: 2px;
}

.loja-check {
    color: var(--cor-loja);
    font-size: 12px;
}

.sem-resultados {
    padding: 20px 14px;
    text-align: center;
    color: #9CA3AF;
    font-size: 13px;
}

.gerenciar-lojas {
    display: block;
    text-align: center;
    padding: 12px 14px;
    color: #9CA3AF;
    font-size: 12px;
    text-decoration: none;
    border-top: 1px solid #f0f0f0;
    transition: all 0.2s ease;
}

.gerenciar-lojas:hover {
    color: var(--cor-loja);
    background: rgba(0, 0, 0, 0.05);
    text-decoration: none;
}

/* Animação do dropdown */
.slide-fade-enter-active {
    transition: all 0.3s ease;
}

.slide-fade-leave-active {
    transition: all 0.2s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateY(-10px);
    opacity: 0;
}

/* Scrollbar personalizada */
.dropdown-lojas::-webkit-scrollbar {
    width: 6px;
}

.dropdown-lojas::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.dropdown-lojas::-webkit-scrollbar-thumb {
    background: var(--cor-loja);
    border-radius: 3px;
}

.dropdown-lojas::-webkit-scrollbar-thumb:hover {
    filter: brightness(0.9);
}
</style>
